var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import AscSvg from './asc.svg';
import DescSvg from './desc.svg';
import QuestionSvg from './question.svg';
import ArrowRightSvg from './arrow-right.svg';
import InfoSvg from './info.svg';
import BigBlueInfoSvg from './big-blue-info.svg';
import FlagSvg from './flag.svg';
import AssessmentTestValuesSvg from './assessment-test-values.svg';
import AssessmentTestLegendSvg from './assessment-legend.svg';
import GradeLegendSvg from './grade-legend.svg';
import DashSvg from './dash.svg';
import ArrowRightClosedSvg from './arrow-right-closed.svg';
import ArrowRightClosedNoLineSvg from './arrow-right-no-line.svg';
import ArrowRightOpenNoLineSvg from './arrow-right-open-no-line.svg';
import CrossSvg from './cross.svg';
import SpinnerSvg from './spinner.svg';
export var AscIcon = function (props) {
    return _jsx(AscSvg, __assign({}, props), void 0);
};
export var DescIcon = function (props) {
    return _jsx(DescSvg, __assign({}, props), void 0);
};
export var QuestionIcon = function (props) {
    return _jsx(QuestionSvg, __assign({}, props), void 0);
};
export var ArrowRightIcon = function (props) {
    return _jsx(ArrowRightSvg, __assign({}, props), void 0);
};
export var InfoIcon = function (props) {
    return _jsx(InfoSvg, __assign({}, props), void 0);
};
export var BigBlueInfoIcon = function (props) {
    return _jsx(BigBlueInfoSvg, __assign({}, props), void 0);
};
export var FlagIcon = function (props) {
    return _jsx(FlagSvg, __assign({}, props), void 0);
};
export var AssessmentTestValues = function (props) {
    return _jsx(AssessmentTestValuesSvg, __assign({}, props), void 0);
};
export var AssessmentTestLegend = function (props) {
    return _jsx(AssessmentTestLegendSvg, __assign({}, props), void 0);
};
export var GradeLegend = function (props) {
    return _jsx(GradeLegendSvg, __assign({}, props), void 0);
};
export var DashIcon = function (props) {
    return _jsx(DashSvg, __assign({}, props), void 0);
};
export var ArrowRightClosedIcon = function (props) {
    return _jsx(ArrowRightClosedSvg, __assign({}, props), void 0);
};
export var ArrowRightClosedNoLineIcon = function (props) {
    return _jsx(ArrowRightClosedNoLineSvg, __assign({}, props), void 0);
};
export var ArrowRightOpenNoLineIcon = function (props) {
    return _jsx(ArrowRightOpenNoLineSvg, __assign({}, props), void 0);
};
export var CrossIcon = function (props) {
    return _jsx(CrossSvg, __assign({}, props), void 0);
};
export var SpinnerIcon = function (props) {
    return _jsx(SpinnerSvg, __assign({}, props), void 0);
};
